// categoryUtils.js v4

export const CATEGORIES = {
  income: { label: "Income", color: "#059669", bg: "#ECFDF5", icon: "💰", deductible: false, group: "Income" },
  investment_income: { label: "Investment Income", color: "#059669", bg: "#ECFDF5", icon: "📈", deductible: false, group: "Income" },
  transfer: { label: "Transfer / Internal", color: "#6B7280", bg: "#F9FAFB", icon: "↔️", deductible: false, group: "Transfer" },
  rental_expenses: { label: "Rental Expenses", color: "#2563EB", bg: "#EFF6FF", icon: "🏠", deductible: true, group: "Deductions" },
  phone_internet: { label: "Phone & Internet", color: "#2563EB", bg: "#EFF6FF", icon: "📱", deductible: true, group: "Deductions" },
  vehicle_transport: { label: "Vehicle & Transport", color: "#2563EB", bg: "#EFF6FF", icon: "🚗", deductible: true, group: "Deductions" },
  bank_fees: { label: "Bank Fees", color: "#2563EB", bg: "#EFF6FF", icon: "🏦", deductible: true, group: "Deductions" },
  donations: { label: "Donations", color: "#2563EB", bg: "#EFF6FF", icon: "❤️", deductible: true, group: "Deductions" },
  education_training: { label: "Education & Training", color: "#2563EB", bg: "#EFF6FF", icon: "📚", deductible: true, group: "Deductions" },
  home_office: { label: "Home Office", color: "#2563EB", bg: "#EFF6FF", icon: "🖥️", deductible: true, group: "Deductions" },
  groceries: { label: "Groceries", color: "#D97706", bg: "#FFFBEB", icon: "🛒", deductible: false, group: "Personal" },
  dining: { label: "Dining & Takeaway", color: "#D97706", bg: "#FFFBEB", icon: "🍽️", deductible: false, group: "Personal" },
  health_medical: { label: "Health & Medical", color: "#DC2626", bg: "#FEF2F2", icon: "⚕️", deductible: false, group: "Personal" },
  insurance: { label: "Insurance", color: "#7C3AED", bg: "#F5F3FF", icon: "🛡️", deductible: false, group: "Personal" },
  shopping_retail: { label: "Shopping & Retail", color: "#D97706", bg: "#FFFBEB", icon: "🛍️", deductible: false, group: "Personal" },
  subscriptions: { label: "Subscriptions", color: "#D97706", bg: "#FFFBEB", icon: "📺", deductible: false, group: "Personal" },
  entertainment: { label: "Entertainment", color: "#D97706", bg: "#FFFBEB", icon: "🎬", deductible: false, group: "Personal" },
  transport_personal: { label: "Personal Transport", color: "#D97706", bg: "#FFFBEB", icon: "🚌", deductible: false, group: "Personal" },
  utilities: { label: "Utilities", color: "#D97706", bg: "#FFFBEB", icon: "💡", deductible: false, group: "Personal" },
  bnpl: { label: "Buy Now Pay Later", color: "#D97706", bg: "#FFFBEB", icon: "💳", deductible: false, group: "Personal" },
  international_purchase: { label: "International Purchase", color: "#6B7280", bg: "#F9FAFB", icon: "🌏", deductible: false, group: "Personal" },
  personal_other: { label: "Personal Expense", color: "#6B7280", bg: "#F9FAFB", icon: "👤", deductible: false, group: "Not Sure" },
  uncategorized: { label: "Needs Review", color: "#6B7280", bg: "#F9FAFB", icon: "❓", deductible: false, group: "Review" },
};

export const CATEGORY_DISPLAY_NAMES = Object.fromEntries(
  Object.entries(CATEGORIES).map(([k, v]) => [k, v.label])
);

export const CATEGORY_GROUPS = {
  Income: Object.entries(CATEGORIES).filter(([, v]) => v.group === "Income").map(([k]) => k),
  Transfer: Object.entries(CATEGORIES).filter(([, v]) => v.group === "Transfer").map(([k]) => k),
  Deductions: Object.entries(CATEGORIES).filter(([, v]) => v.group === "Deductions").map(([k]) => k),
  Personal: Object.entries(CATEGORIES).filter(([, v]) => v.group === "Personal").map(([k]) => k),
  "Not Sure": Object.entries(CATEGORIES).filter(([, v]) => v.group === "Not Sure").map(([k]) => k),
  Review: Object.entries(CATEGORIES).filter(([, v]) => v.group === "Review").map(([k]) => k),
};

export const TAX_DEDUCTIBLE_CATEGORIES = Object.entries(CATEGORIES)
  .filter(([, v]) => v.deductible)
  .map(([k]) => k);

export const ATO_LAST_REVIEWED = "April 2026";

export const TAX_GUIDANCE_RULES = {
  vehicle_transport: "Work-related travel only. Home-to-work commute is NOT deductible. Keep a logbook.",
  phone_internet: "Only the work-related percentage is deductible. Document your usage split.",
  home_office: "Use ATO fixed rate (67c/hr) or actual cost method. Do not double-dip.",
  education_training: "Must relate directly to your current job to be deductible.",
  donations: "Must be to a registered DGR charity. Gifts must be $2 or more.",
  rental_expenses: "Deductible in proportion to rental income periods only.",
};

export const DOUBLE_DIP_WARNINGS = [
  { categories: ["vehicle_transport", "home_office"], message: "You have both Vehicle and Home Office claims. Ensure travel is work-related and not already covered by home office deduction." },
  { categories: ["phone_internet", "home_office"], message: "Phone/internet and home office both claimed. Ensure you are not double-counting internet costs." },
];

export const ATO_CATEGORIES = CATEGORIES;

export function getCategoryInfo(categoryKey) { return CATEGORIES[categoryKey] || CATEGORIES.uncategorized; }
export function getCategoryLabel(categoryKey) { return getCategoryInfo(categoryKey).label; }
export function getCategoryColor(categoryKey) { return getCategoryInfo(categoryKey).color; }
export function getCategoryBg(categoryKey) { return getCategoryInfo(categoryKey).bg; }
export function isDeductible(categoryKey) { return getCategoryInfo(categoryKey).deductible; }
export function getCategoryOptions() { return Object.entries(CATEGORIES).map(([key, val]) => ({ value: key, label: val.label, group: val.group, deductible: val.deductible, color: val.color })); }
export function getDeductibleCategories() { return TAX_DEDUCTIBLE_CATEGORIES; }
